// extracted by mini-css-extract-plugin
module.exports = {"video":"styles_video__oCAKy","top":"styles_top__RJKA_","bottom":"styles_bottom__W3RmB","three-quarters":"styles_three-quarters__N8RBM"};